import {
  apiVersion,
  apiEndpoints,
  apiEndpointsSSR,
  getShopApiEndpointSSR,
  apiEndpointsCommunity,
  webProtocols,
  webHosts,
  getShopWebHost,
  facebookAppId,
  cookiesDomains,
  reCaptchaKey,
  amplifyConfig,
  sentryConfig,
  sentryConfigCabinets,
  marketingWebHosts,
  metabaseHosts,
} from 'libs/configs'
import { getRuntimeEnvironment } from 'libs/runtime-config'
// eslint-disable-next-line
import { LocalStorageService } from 'utils/local-storage.utils'

const integrationServiceEndpoints = {
  test: 'https://auth.staging.myablefy.com',
  development: 'https://auth.staging.myablefy.com',
  staging: 'https://auth.staging.myablefy.com',
  uat: 'https://auth.uat.myablefy.com',
  production: 'https://auth.myablefy.com',
}

const elopageConfig = {
  apiVersion,
  mode: process.env.NODE_ENV,
  env: process.env.ENV,
  apiPath: apiEndpoints[process.env.ENV],
  apiPathSSR: apiEndpointsSSR[process.env.ENV],
  apiPathCommunity: apiEndpointsCommunity[process.env.ENV],
  fbAppId: facebookAppId,
  webHost: webHosts[process.env.ENV],
  webProtocol: webProtocols[process.env.ENV],
  cookiesDomain: cookiesDomains[process.env.ENV],
  reCaptchaKey,
  amplifyConfig: amplifyConfig[process.env.ENV],
  integrationServiceHost: integrationServiceEndpoints[process.env.ENV],
  hostname: '',
  isNextApp: process.env.NEXT_PUBLIC_IS_NEXT_JS_APP,
  sentryConfig: sentryConfig[process.env.ENV],
  sentryConfigCabinets: sentryConfigCabinets[process.env.ENV],
  marketingWebHost: marketingWebHosts[process.env.ENV],
  metabaseHost: metabaseHosts[process.env.ENV],
}

type ElopageConfigKey = keyof typeof elopageConfig
type AmplifyConfig = keyof typeof amplifyConfig.production
type SentryConfig = keyof typeof sentryConfig.production
type ElopageConfig = string | AmplifyConfig | SentryConfig

const environmentConfigs: Record<string, Record<string, unknown>> = {
  apiPath: apiEndpoints,
  apiPathSSR: apiEndpointsSSR,
  apiPathCommunity: apiEndpointsCommunity,
  webHost: webHosts,
  webProtocol: webProtocols,
  cookiesDomain: cookiesDomains,
  amplifyConfig,
  integrationServiceHost: integrationServiceEndpoints,
  sentryConfig,
  sentryConfigCabinets,
  marketingWebHost: marketingWebHosts,
  metabaseHost: metabaseHosts,
}

const explicitlyOverriddenConfigKeys = new Set<ElopageConfigKey>()

const getEnvironmentConfig = (key: ElopageConfigKey): ElopageConfig | undefined => {
  const environment = getRuntimeEnvironment()
  const config = environmentConfigs[key]

  return environment && config ? (config[environment] as ElopageConfig | undefined) : undefined
}

export const getElopageConfig = (key: ElopageConfigKey): ElopageConfig => {
  if (explicitlyOverriddenConfigKeys.has(key)) return elopageConfig[key]

  if (key === 'env') return getRuntimeEnvironment() || elopageConfig.env

  if (process.env.NEXT_PUBLIC_IS_NEXT_JS_APP === 'true') {
    if (key === 'apiPathSSR') return getShopApiEndpointSSR()
    if (key === 'webHost') return getShopWebHost()
  }

  return getEnvironmentConfig(key) || elopageConfig[key]
}

export const setElopageConfig = (key: ElopageConfigKey, value: string): void => {
  explicitlyOverriddenConfigKeys.add(key)
  elopageConfig[key] = value
}

//TODO: Need to set the correct date  before release
export const getBundleBanDate = () => LocalStorageService.getItem('bundleBanDate') || '2022-11-10'
